import { BrowserRouter, Routes, Route } from "react-router-dom";
import RequireAuth from "./components/ProtectedRoute";

import React from "react";
import SignIn from "./pages/SignIn";

import Loader from "./components/Loader.js";
import Create from "./pages/Create";
import CreateResource from "./pages/CreateResource";
import PostDetails from "./pages/PostDetails";
import ResourecePost from "./components/ResourcesPost";
import Annoucement from "./pages/Annoucement";

const Login = React.lazy(() => import("./pages/Login.js"));
const DashBoard = React.lazy(() => import("./pages/DashBoard.js"));
const About = React.lazy(() => import("./pages/About.js"));
const RouteElement = () => {
  return (
    <>
      <BrowserRouter>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignIn />} />

            <Route element={<RequireAuth />}>
              <Route path="/create" element={<Create />} />
              <Route path="/createResource" element={<CreateResource />} />
              <Route path="/Annoucements" element={<Annoucement />} />
              <Route path="/:usn" element={<About />} />
              <Route path="/post/:id" element={<PostDetails />} />

              <Route path="/" element={<DashBoard />} />
            </Route>
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </>
  );
};
export default RouteElement;
